var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgUserLightBlue80040X40(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2429 4.39966C13.1706 4.39275 13.0982 4.39275 13.026 4.39966C11.9998 4.348 11.1894 3.50129 11.1894 2.46006C11.1894 1.38752 12.0599 0.510738 13.1387 0.510738C14.2107 0.510738 15.0871 1.38045 15.088 2.45845C15.0804 3.50201 14.268 4.34803 13.2429 4.39966Z",
    fill: "#0074BB",
    stroke: "#0074BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.715 10.3861L15.7148 10.3863C15.0445 10.8351 14.1288 11.0693 13.2012 11.064C13.3851 10.4859 13.4812 9.8734 13.4878 9.24118L13.4878 9.24118V9.23586C13.4878 8.57191 13.383 7.92726 13.1777 7.32705C14.1169 7.31843 15.0319 7.55275 15.708 8.0015L15.708 8.0015L15.7096 8.00257C16.2754 8.375 16.4888 8.81586 16.4895 9.19103C16.4901 9.56676 16.2778 10.0097 15.715 10.3861Z",
    fill: "#0074BB",
    stroke: "#0074BB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78342 4.9116C3.84301 4.90309 3.90259 4.90309 3.96218 4.9116C5.28158 4.86904 6.3286 3.78797 6.3286 2.46006C6.3286 1.09809 5.23051 0 3.86854 0C2.51509 0 1.417 1.09809 1.417 2.46006C1.417 3.78797 2.46401 4.86904 3.78342 4.9116Z",
    fill: "#0074BB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87735 9.23502C3.87735 10.0607 4.05611 10.8438 4.37958 11.5504C3.17935 11.6781 1.92804 11.4227 1.00871 10.8183C-0.336236 9.92452 -0.336236 8.46892 1.00871 7.57512C1.91952 6.96224 3.20488 6.71538 4.41363 6.85158C4.06462 7.56661 3.87735 8.37528 3.87735 9.23502Z",
    fill: "#0074BB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61861 11.8062C8.55051 11.7977 8.4739 11.7977 8.39729 11.8062C6.83102 11.7552 5.57971 10.4698 5.57971 8.88651C5.58823 7.26917 6.89061 5.95828 8.51646 5.95828C10.1338 5.95828 11.4447 7.26917 11.4447 8.88651C11.4362 10.4698 10.1934 11.7552 8.61861 11.8062Z",
    fill: "#0074BB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85194 13.5685C4.56658 14.4282 4.56658 15.8413 5.85194 16.6925C7.31606 17.6714 9.71653 17.6714 11.1806 16.6925C12.466 15.8328 12.466 14.4197 11.1806 13.5685C9.72504 12.5896 7.32457 12.5896 5.85194 13.5685Z",
    fill: "#0074BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgUserLightBlue80040X40);
export default __webpack_public_path__ + "static/media/img_user_light_blue_800_40x40.b84d39f86cd669f6a728a9dc2a2a76dd.svg";
export { ForwardRef as ReactComponent };